module.exports = __webpack_public_path__ + "files/a26e5295db8139dc0c231ae8fa538aec.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/skintone-20.png
// module id = 1509
// module chunks = 60